import { render, staticRenderFns } from "./ReportCardComponent.vue?vue&type=template&id=cbd560f6&scoped=true&"
import script from "./ReportCardComponent.vue?vue&type=script&lang=js&"
export * from "./ReportCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportCardComponent.vue?vue&type=style&index=0&id=cbd560f6&prod&lang=css&"
import style1 from "./ReportCardComponent.vue?vue&type=style&index=1&id=cbd560f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd560f6",
  null
  
)

export default component.exports